export function showLocationInfo() {
    const $locationSelect = $(".locations-info select");

    $locationSelect.on("change", function () {
        const $this = $(this);
        const $parent = $this.closest(".locations-info");
        const $listItems = $parent.find(".locations-info-box li");

        $listItems.eq($this.val()).addClass("active").siblings().removeClass("active");
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/show-location-info.js